import { RefObject, useCallback, useEffect } from 'react';

const useDetectClickOutsideAndKeyDownEscOrTab = (ref: RefObject<HTMLElement>, callback: () => void): void => {
    const handleClickOutside = (event: MouseEvent) => {
        if (ref?.current && !ref?.current.contains(event.target as Node)) {
            callback();
        }
    };

    const handleEscOrTabClick = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Escape' || event.key === 'Esc' || event.key === 'Tab') {
                event.stopPropagation();
                callback();
            }
        },
        [callback],
    );

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscOrTabClick);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscOrTabClick);
        };
    });
};

export default useDetectClickOutsideAndKeyDownEscOrTab;
